import { useQuery } from '@tanstack/react-query';
import { fetchCarePlanMedianScores } from '../services/care_plan';

// `enabled` lets the caller hold the request back until the user has actually
// asked for a median over a range — the endpoint is only hit on demand.
const useCarePlanMedianScore = (patientId, fromDate, toDate, enabled = true) => {
    return useQuery({
        queryKey: ['carePlanMedianScores', patientId, fromDate, toDate],
        queryFn: () => fetchCarePlanMedianScores(patientId, fromDate, toDate),
        enabled: !!patientId && enabled,
        staleTime: 0,
    });
};

export default useCarePlanMedianScore;
